import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MdMenu } from 'react-icons/md';
import Sidebar from '../components/Sidebar';
import ErrorBoundary from '../components/ErrorBoundary';
import { HospitalProfileProvider } from '../auth/HospitalProfileContext';
import { useAuth } from '../auth/AuthContext';

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  // Close drawer on navigation (phone)
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Lock body scroll when drawer open
  useEffect(() => {
    if (!mobileOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [mobileOpen]);

  return (
    <HospitalProfileProvider>
      <div className={`app-shell${mobileOpen ? ' mobile-nav-open' : ''}`}>
        <header className="mobile-topbar">
          <button
            type="button"
            className="mobile-menu-btn"
            aria-label="Open menu"
            onClick={() => setMobileOpen(true)}
          >
            <MdMenu size={24} />
          </button>
          <div className="mobile-topbar-brand">
            <img src={`${process.env.PUBLIC_URL || ''}/hcen_logo.png`} alt="" className="mobile-topbar-logo" />
            <div>
              <div className="mobile-topbar-title">HCEN HMS</div>
              <div className="mobile-topbar-sub">{user?.roleLabel || user?.role || 'Staff'}</div>
            </div>
          </div>
        </header>

        {mobileOpen && (
          <button
            type="button"
            className="mobile-nav-backdrop"
            aria-label="Close menu"
            onClick={() => setMobileOpen(false)}
          />
        )}

        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        <main
          className="app-main"
          style={{ marginLeft: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)' }}
        >
          <ErrorBoundary fallback="/manager/dashboard" title="Page error">
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </HospitalProfileProvider>
  );
}
